const data = [
    { id: 1, name: "Apoio a Equipes de Campo" },
    { id: 2, name: "Assuntos Trabalhistas - RH" },
    { id: 3, name: "Atividades de Responsabilidade Social" },
    { id: 4, name: "Desligamento" },
    { id: 5, name: "Deslocamento para Treinamentos Externos" },
    { id: 6, name: "Emergências Médicas" },
    { id: 7, name: "Entrega de Documentos" },
    { id: 8, name: "Envio de Amostras/Equipamentos" },
    { id: 9, name: "Evento Corporativo" },
    { id: 10, name: "Exame Ocupacional" },
    { id: 11, name: "Indisponibilidade de Lugar no Transporte Fretado" },
    { id: 12, name: "Deslocamento para Treinamentos Externos" },
    { id: 13, name: "Inspeções de Campo" },
    { id: 14, name: "Inspeções de Segurança" },
    { id: 15, name: "Manutenção Técnica" },
    { id: 16, name: "Parada de Manutenção" },
    { id: 17, name: "Partida de Linha" },
    { id: 18, name: "Projeto" },
    { id: 19, name: "Reposição para Mínimo de Grupo" },
    { id: 20, name: "Suporte a Eventos Internos" },
    { id: 21, name: "Treinamento" },
    { id: 22, name: "Viagens de Negócios" },
    { id: 23, name: "Visitas de Auditoria" }

  ];
  
  export default [...data];
  